import React from 'react';
import { Helmet } from 'react-helmet-async';

const StructuredData = ({ settings }) => {
    // Só gera os dados estruturados se as informações essenciais existirem
    if (!settings || !settings.siteName || !settings.streetAddress || !settings.addressLocality) {
        return null;
    }

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "BarberShop", // Define o tipo de negócio como Barbearia
        "name": settings.siteName,
        "image": settings.logoUrl || '',
        "address": {
            "@type": "PostalAddress",
            "streetAddress": settings.streetAddress,
            "addressLocality": settings.addressLocality,
            "postalCode": settings.postalCode,
            "addressCountry": "BR" // Definido como Brasil
        },
        "telephone": settings.telephone,
        "url": window.location.href // Usa a URL atual do site
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(structuredData)}
            </script>
        </Helmet>
    );
};

export default StructuredData;
